var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var open = {
    display: 'flex',
};
export var modal = (_a = {
        background: '#FFFFFF',
        borderRadius: 16,
        borderColor: '#DFE5EB',
        borderWidth: 1,
        boxShadow: '0px 4px 8px 2px hsba(207, 31%, 28%, 0.08)',
        display: 'none',
        flexDirection: 'column',
        left: '50%',
        maxHeight: 'calc(100% - 25px)',
        minHeight: 200,
        minWidth: 400,
        maxWidth: 640,
        outline: 0,
        position: 'fixed',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        transition: 'all .3s',
        zIndex: 910
    },
    _a["@media ".concat(mobile(700))] = {
        minWidth: '90%',
        maxWidth: '90% !important',
        maxHeight: '90% !important',
    },
    _a['@media screen and (prefers-reduced-motion: reduce)'] = {
        transition: 'none',
    },
    _a);
export var small = __assign(__assign({}, modal), (_b = { maxHeight: 'calc(100% - 200px)', maxWidth: 400 }, _b["@media ".concat(mobile(1024))] = {
    width: '75%',
}, _b["@media ".concat(mobile(860))] = {
    width: '90%',
}, _b["@media ".concat(mobile(700))] = {
    minWidth: '90%',
}, _b));
export var large = __assign(__assign({}, modal), { maxWidth: 1240 });
export var header = (_c = {
        alignItems: 'top',
        display: 'flex',
        justifyContent: 'space-between',
        padding: "".concat(16, "px ").concat(24, "px"),
        borderBottom: "1px solid ".concat('#DFE5EB')
    },
    _c["@media ".concat(mobile(700))] = {
        padding: "".concat(12 - 2, "px ").concat(16, "px ").concat(12 - 2, "px ").concat(24, "px"),
    },
    _c);
export var headerText = (_d = {
        marginRight: "".concat(16, "px"),
        color: '#000',
        flexGrow: 1,
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '150%'
    },
    _d["@media ".concat(mobile(700))] = {
        fontSize: 20,
    },
    _d.paddingBlock = 4,
    _d);
export var headerIcon = {
    color: '#000',
};
export var body = {
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: 24,
    position: 'relative',
    '& p': {
        fontSize: 16,
        lineHeight: "".concat('150%', "px"),
        fontWeight: 400,
    },
};
export var footer = {
    background: '#F5F8FA',
    borderRadius: "0 0 ".concat(24, "px ").concat(24, "px"),
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
};
export var overlay = {
    label: 'overlay',
    bottom: 0,
    content: '""',
    cursor: 'default',
    height: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    transition: 'background 0.3s linear',
    width: '100%',
    zIndex: 901,
    '@media screen and (prefers-reduced-motion: reduce)': {
        transition: 'none',
    },
};
export var overlayOpen = {
    height: '100%',
    background: 'rgba(17, 30, 40, 0.5)',
};
export var overlayOpenBody = {
    overflow: 'hidden',
};
